export const VideoKycErrorTypeEnum = {
aadharNotUploaded:"aadharNotUploaded",
aadharUploadedDateExceeds:"aadharUploadedDateExceeds"
}